import gql from 'graphql-tag';

export const mutationCreateStripeCustomerPortalSession = gql`
  mutation createStripeCustomerPortalSession {
    createStripeCustomerPortalSession
  }
`;
export default mutationCreateStripeCustomerPortalSession;
